import { render, staticRenderFns } from "./ProtocolApprover.vue?vue&type=template&id=a04a56e2&"
import script from "./ProtocolApprover.vue?vue&type=script&lang=js&"
export * from "./ProtocolApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports